import React, { lazy } from 'react';
import { useUserContext } from 'UserContext';
const AdminNav = lazy(() => import('../internal/shared/Navigation'));
import PublicNavBar from 'parent-portal/LandingPages/Shared/ActionNavBar/PublicNavBar';
import StakeholderNav from '../internal/sub-pool-stakeholder/StakeholderNav';

const noHeaderRoutes = [
    '/sitter/',
    '/providers/ambassador/',
    '/parent-verification',
    '/job-request',
    '/providers/home',
    '/gotandem',
];

const forcePublicNavRoutes = ['/signin/change/password', '/signin/create/password'];

const stakeholderRoutes = ['/sub-pool-stakeholder/'];

const Navigation = () => {
    const { user, role } = useUserContext();

    if (stakeholderRoutes.some((x) => window.location.pathname.startsWith(x))) {
        return <StakeholderNav />;
    }

    if (forcePublicNavRoutes.some((x) => window.location.pathname.startsWith(x))) {
        return <PublicNavBar />;
    }

    if (noHeaderRoutes.some((x) => window.location.pathname.startsWith(x))) {
        return <></>;
    }

    if (!user || user.signup_page < 4) {
        return <PublicNavBar />;
    }

    if (role === 'admin') {
        return <AdminNav />;
    }

    return <></>;
};

export default Navigation;
